import planLabel from './plan-label';

// Mixpanel のプロフィールに載せる利用状況。
//
// 無料枠に対してどれだけ使っているかを mapLoadRatio で持たせる。これが
// あると、利用者を消費率で分布させて「無料枠に収まっているのか、
// 溢れているのに払っていないのか」を見分けられる。
//
// 表示回数はチーム単位、Mixpanel のプロフィールはユーザー単位なので、
// 複数チームに所属する人は選択中のチームの値で上書きされる。どのチームの
// 数値かが後から分かるように teamId も一緒に持たせる。

type Input = {
  count: unknown;
  limit: number;
  planId: string | null | undefined;
  teamId: string;
};

export type UsageProfile = {
  mapLoadCount: number;
  /** 無制限のときは null。 */
  mapLoadLimit: number | null;
  /** 上限に対する消費率。無制限のときは null。 */
  mapLoadRatio: number | null;
  plan: string;
  teamId: string;
};

const usageProfile = ({ count, limit, planId, teamId }: Input): UsageProfile | null => {
  // 負の回数は集計の不整合でしか起こらない。そのまま送ると mapLoadRatio も
  // 負になり、分布が読めなくなる。
  if (typeof count !== 'number' || !Number.isFinite(count) || count < 0) {
    return null;
  }

  if (!teamId) {
    return null;
  }

  const hasLimit = Number.isFinite(limit) && limit > 0;

  return {
    mapLoadCount: count,
    mapLoadLimit: hasLimit ? limit : null,
    // 小数第3位まで。上限の 0.1% 単位で、分布を見るには十分な粒度。
    mapLoadRatio: hasLimit ? Math.round((count / limit) * 1000) / 1000 : null,
    plan: planLabel(planId),
    teamId,
  };
};

export default usageProfile;
